import React from "react";
import PageLayout from "../UI/PageLayout";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";
import PageContentSettings from "../../containers/Settings/PageContentSettingsPage";

const PageContentSettingsPage = () => {

  return (
    <PageLayout
      title="Page Content Settings"
      subTitle="Customize the layout and content of various pages in the application"
      dropdowns={<GenericReportingDropdowns
        includeDateRange={false}
        includeRegion={false}
        includeGranularity={false}
        includeTooltipsAndTitles={false}
        containerStyle="dropdown-container"
        renderAsButton={true}
        includeCompareDateRange={false}
      />}
      content={<PageContentSettings />}
    />
  );
};

export default PageContentSettingsPage;
